export default __webpack_public_path__ + "static/media/close.a650c387.svg";